
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import useTubingFacade from "../../../../facade/calculation/calculation-input/tubing.facade";
import useMotorFacade from "../../../../facade/calculation/calculation-output/motor-facade";
import Accordion from "../../../common/accordion";
import TableComponent from "../../../common/TableComponent";
import LABELS from "../../../../constants/labels/motor.labels";
import Dropdown from "../../../common/dropdown";
import Checkbox from "../../../common/checkbox";
import React, { useEffect, useRef, useState } from "react";
import { MotorDto } from "../../../../store/model/calculations/motor";
import EquipmentTableAddChargePump from "../../../common/equipment-table-charge-pump";
import useCalculationFacade from "../../../../facade/calculation/calculation.facade";
import { setGasNotification } from "../../../../store/calculation/calculation-output/gasCalculaionSlice";
import Select from "../../../common/select";
import useCableFacade from "../../../../facade/calculation/calculation-output/cable.facade";
import TextShortInput from "../../../common/TextShortInput";

const MotorList = () => {
  const { motorListCollapse } = useAppSelector((state) => state?.collapse);
  const equipments = useAppSelector((state) => state?.motor.Equipments);
  const { projectDetails } = useAppSelector((state) => state?.calculations);
  const tableRef = useRef<HTMLDivElement>(null);

  const [maxEquipmentLimit, setMaxEquipmentLimit] = useState<number>(4);
  const { tab3Input } = useAppSelector((state) => state?.fluid);
  const { gasHandlerPumpName } = useAppSelector((state) => state?.gasHandler);
  const { tab1Input } = useAppSelector((state) => state?.tubing);
  const { BasicGasCalculation, GasCalculationOutPut, hPRating } =
    useAppSelector((state) => state?.gasCalculations);
  const { MotorInput, motor_HPInput, MotorList, SelectedMotor, ESPEquipments } =
    useAppSelector((state) => state?.motor);
  const { PumpInputCalculated } = useAppSelector((state) => state?.pump);
  const [equipmentsList, setEquipmentsList] = useState<any>([]);

  useEffect(() => {
    setEquipmentsList(equipments);
  }, [equipments]);

  const tableColumns = [
    { key: "name", title: "Names", dataIndex: "name" },
    { key: "series", title: "Series", dataIndex: "series" },
    { key: "kw", title: "kW", dataIndex: "kw" },
    {
      key: "baseHP",
      title: `Power ${tab1Input?.actNameMotor_TPower}`,
      dataIndex: "baseHP",
    },
    {
      key: "voltage",
      title: `Volts ${tab1Input?.actNameMotor_TVoltage}`,
      dataIndex: "voltage",
    },
    {
      key: "current",
      title: `Current ${tab1Input?.actNameMotor_TCurrent}`,
      dataIndex: "current",
    },
    {
      key: "maxBottomHoleTemp",
      title: `Max BH Temp ${tab1Input?.actNameMotor_TBHTemp}`,
      dataIndex: "maxBottomHoleTemp",
    },
    {
      key: "maxOperatingTemp",
      title: `Max optng temp ${tab1Input?.actNameMotor_TOperatingTemp}`,
      dataIndex: "maxOperatingTemp",
    },
    {
      key: "motorOD",
      title: `Motor OD ${tab1Input?.actNameMotor_TMotorOD}`,
      dataIndex: "motorOD",
    },
  ];

  const { updateMotorListCollapse } = useCollapseFacade();
  const {
    UpdatehdnMotrAutoHP,
    UpdatehdnMotrShowAll,
    UpdatehdnMotorSeries,
    updateHiddenMotorId,
  } = useTubingFacade();
  const {
    updateMotorHP,
    updateSelectedMotor,
    updateESPEquipmentsForMotor,
    updateMotorRating,
  } = useMotorFacade();
  const { updateSchematicEquipmentData } = useCalculationFacade();
  const { updateCableMotorLead } = useCableFacade();

  const handleCollapseChange = (key: boolean) => {
    updateMotorListCollapse(key);
  };
  useEffect(() => {
    const lastIndex = ESPEquipments.length - 1;
    const lastEquipment = ESPEquipments[lastIndex];
    if (ESPEquipments.length === 1 && lastEquipment?.configuration === "SINGLE") return;
    if ((ESPEquipments.length === 2 || ESPEquipments.length === 3) && lastEquipment?.configuration === "LT") return;
    if (ESPEquipments.some((item, idx) => Object.keys(item).length === 0 && idx !== lastIndex)) return;
    if (Object.keys(lastEquipment || {}).length === 0) return;
    if (ESPEquipments.length < 4) {
      updateESPEquipmentsForMotor([...ESPEquipments, {}]);
    }
  }, [ESPEquipments]);


  const handleChangeMotorEquipment = (equipment: any, rowIndex: number) => {
    const updatedEquipments = [...ESPEquipments];
    updatedEquipments[rowIndex] = equipment;
    if (rowIndex === 0) {
      if (equipment.configuration === "SINGLE") {
        updateESPEquipmentsForMotor(updatedEquipments.slice(0, 1));
        updateSchematicEquipmentData();
        return;
      }
      if (equipment.configuration === "UT") {
        if (updatedEquipments.length < 2) {
          updateESPEquipmentsForMotor([...updatedEquipments, {}]);
          updateSchematicEquipmentData();
          return;
        }
      }
      if (!equipment.configuration) {
        updateESPEquipmentsForMotor(updatedEquipments.slice(0, 1));
        updateSchematicEquipmentData();
        return;
      }
    }
    if (rowIndex === 1) {
      if (equipment.configuration === "LT") {
        updateESPEquipmentsForMotor(updatedEquipments.slice(0, 2));
        updateSchematicEquipmentData();
        return;
      }
      if (equipment.configuration === "CT" && updatedEquipments.length < 3) {
        updateESPEquipmentsForMotor([...updatedEquipments, {}]);
        updateSchematicEquipmentData();
        return;
      }
      if (!equipment.configuration) {
        updateESPEquipmentsForMotor(updatedEquipments.slice(0, 2));
        updateSchematicEquipmentData();
        return;
      }
    }
    if (rowIndex === 2) {
      if (equipment.configuration === "LT") {
        updateESPEquipmentsForMotor(updatedEquipments.slice(0, 3));
        updateSchematicEquipmentData();
        return;
      }
      if (equipment.configuration === "CT" && updatedEquipments.length < 4) {
        updateESPEquipmentsForMotor([
          ...updatedEquipments,
          {
            id: "",
            name: "",
            configuration: "",
            voltage: 0,
            current: 0,
            size: 0,
          },
        ]);
        updateSchematicEquipmentData();
        return;
      }
      if (!equipment.configuration) {
        updateESPEquipmentsForMotor(updatedEquipments.slice(0, 3));
        updateSchematicEquipmentData();
        return;
      }
    }
    if (rowIndex === 3) {
      updateESPEquipmentsForMotor(updatedEquipments.slice(0, 4));
      updateSchematicEquipmentData();
      return;
    }

    updateESPEquipmentsForMotor(updatedEquipments);
    updateSchematicEquipmentData();
  };

  const EspEquipmentsClear = (id: String, index: number) => {
    const ESPEquipmentsForMotor = [...ESPEquipments];
    const filtered = ESPEquipmentsForMotor.filter((x, i) => i < index);
    updateESPEquipmentsForMotor([...filtered, {}]);
    updateSchematicEquipmentData();
  };

  const handleRowClick = (motor: MotorDto) => {
    if (motor?.id != tab1Input?.hiddenMotrID) {
      updateHiddenMotorId(motor?.id);
      updateSelectedMotor(motor);
      updateMotorRating(100);
      updateCableMotorLead(motor?.id);
      updateESPEquipmentsForMotor([]);
      updateSchematicEquipmentData();
      UpdatehdnMotorSeries(tab1Input?.hiddenMotrSers ?? motor?.series.toString())
    }
  };

  const handleSelect = (option: any) => {
    UpdatehdnMotorSeries(option?.value.toString());
  };

  const onChangeMotoHPInput = async (e: any) => {
    const { value } = e.target;
    updateMotorHP(value);
  };

  const handleCheckbox = (
    event: React.ChangeEvent<HTMLInputElement>,
    type: "Auto" | "ShowAllMotors"
  ) => {
    const data = event?.target?.checked;
    if (type === "Auto") {
      UpdatehdnMotrAutoHP(Number(data)?.toString());
    } else if (type == "ShowAllMotors") {
      UpdatehdnMotrShowAll(Number(data)?.toString());
    }
  };

  return (
    <Accordion
      tooltipText="Formulas"
      title={`Motor list @ 60Hz`}
      link={'/help?tab=Motor#MotorCal'}
      text={`No. of records: ${MotorList?.length || 0}`}
      isOpen={motorListCollapse}
      onToggle={() => handleCollapseChange(!motorListCollapse)}
      content={
        <>
          <div className="flex justify-center items-start p-4 pb-0 gap-4 w-full">
            <div className="flex flex-col justify-between items-center w-1/2">
              <div className="flex justify-between items-center w-full">
                <label className="text-neutral-25 text-[18px] font-normal">
                  {LABELS.TotalPowerRequired}
                </label>
                <Checkbox
                  label={LABELS.Auto}
                  checked={tab1Input?.hdnMotrAutoHP === "1"}
                  name="Auto"
                  onChange={(e) => handleCheckbox(e, "Auto")}
                />
              </div>
            </div>
            <div className="flex flex-col justify-between items-center w-1/2 align-top">
              <div className="flex justify-between items-center w-full">
                <label className="text-neutral-25 text-[18px] font-normal">
                  {LABELS.MotorSeries}
                </label>
                <Checkbox
                  label={LABELS.ShowAllMotors}
                  checked={tab1Input?.hdnMotrShowAll === "1"}
                  name="ShowAllMotors"
                  onChange={(e) => handleCheckbox(e, "ShowAllMotors")}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-center items-start p-4 gap-4 w-full">
            <div className="flex flex-col items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2">
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                <label className="text-neutral-25 text-[14px] font-normal">
                  {LABELS.hpAt} {tab3Input?.operatngFreq} Hz
                </label>
                <TextShortInput
                  placeholder=""
                  type="number"
                  value={motor_HPInput}
                  onChange={onChangeMotoHPInput}
                  disabled={tab1Input?.hdnMotrAutoHP === "1"}
                  name="motorHPInput"
                  className="px-[12px] py-[10px] rounded-[8px] border-[1px] border-darkcolor-400 bg-transparent text-neutral-25 focus:outline-none text-[16px] text-right hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
                />
              </div>
              <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                <label className="text-neutral-25">{LABELS.hpAt60}</label>
                <label className="text-neutral-25">
                  {MotorInput?.motor_HP60Input}
                </label>
              </div>
            </div>
            <div className="flex flex-col justify-between items-center w-1/2 align-top">
              <div className=" justify-between items-center w-full">
                <label className="text-neutral-25">
                  <Select
                    options={[
                      { value: "0", label: "All" },
                      { value: "375", label: "375" },
                      { value: "406", label: "406" },
                      { value: "420", label: "420" },
                      { value: "456", label: "456" },
                      { value: "540", label: "540" },
                      { value: "562", label: "562" },
                    ]}
                    onChange={handleSelect}
                    selectedValue={tab1Input?.hiddenMotrSers ?? "0"}
                    name={"MotorSeriesList"}
                    padding="px-[14px] py-[5px]"
                    fontSize="16px"
                    className="sm:px-0 px-[10px] w-full"
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="items-center mb-[20px] space-y-4 md:space-y-0 p-4 pt-0">
            <TableComponent
              name={"motorList"}
              data={MotorList}
              rowsPerPage={50}
              columns={tableColumns}
              singleExpandMode={true}
              clickableRows={true}
              ref={tableRef}
              emptyIcon={true}
              pagination={false}
              hiddenMotorId={tab1Input?.hiddenMotrID}
              onRowClick={(row) => handleRowClick(row)}
              // height={465}
              overFlowClass="overflow-auto !static"
              renderExpandedRow={(row) =>
                row.errorMessage ? (
                  <div className="p-2 text-red-500 bg-red-200 rounded">
                    {row.errorMessage}
                  </div>
                ) : (
                  <EquipmentTableAddChargePump
                    isMotorListMode={true}
                    options={equipmentsList?.map((item: any) => {
                      return {
                        ...item,
                        label: item?.pN_Description,
                        value: item?.id,
                      };
                    })}
                    equipments={
                      ESPEquipments?.length > 0 ? ESPEquipments : [{}]
                    }
                    onClear={EspEquipmentsClear}
                    onChange={handleChangeMotorEquipment}
                    parentRef={tableRef}
                    rowLength={maxEquipmentLimit}
                    equipmentGridParentContainer="SRMotorList"
                  />
                )
              }
            />
          </div>
        </>
      }
    />
  );
};

export default MotorList;
